/* eslint-disable max-len */
import React from 'react';

const Quotes = () => (
  <div className="Quotes">
    <p>
      “ Life is a math equation. In order to gain the most, you have to know how to convert negatives into positives.” - Steven Wright.
    </p>
  </div>
);
export default Quotes;
